import { render, staticRenderFns } from "./SvgX.vue?vue&type=template&id=7a67b70d&lang=pug&"
import script from "./SvgX.vue?vue&type=script&lang=js&"
export * from "./SvgX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports